import { Section } from "shared/components/section/Section";
import { ImHammer2 } from "react-icons/im";
import { ReactNode, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import TextInput from "shared/components/input/TextInput";
import CustomButton from "shared/components/button/CustomButton";
import { BsEye } from "react-icons/bs";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";
import ModalAdicionarProcessoJudicialHistorico from "./ModalAdicionarProcessoJudicialHistorico";
import { AiOutlinePlus } from "react-icons/ai";
import SelectAsync from "shared/components/select/SelectAsync";
import { api } from "constants/RotasAPI";
import { usePutAtualizarProcessoJudicial } from "hooks/processosJudiciais/usePutAtualizarProcessoJudicial";
import { ProcessosJudiciaisDTO } from "types/dto/ProcessosJudiciaisDTO";
import VisualizacaoInput from "shared/components/input/VisualizacaoInput";
import ModalVisualizarProcessoJudicialHistorico from "./ModalVisualizarProcessoJudicialHistorico";
import { queryClient } from "shared/util/queryClient";
import { yupResolver } from "@hookform/resolvers/yup";
import { DetalhesProcessoJudicialSchema } from "shared/yup/schemas/DetalhesProcessoJudicialSchema";
import { useForm } from "react-hook-form";
import { SelectOptionType } from "types/select/SelectOptionType";
import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";

interface DetalhesDoProcessoProps {
  processoId?: number | null | undefined;
  unidadeId?: number | null | undefined;
  processsoJudicial?: ProcessosJudiciaisDTO | undefined;
  isVisualizacao: boolean;
}

interface DetalhesDoProcessoForm {
  advogado?: string | null | undefined;
  cartorio?: string | null | undefined;
  uf?: SelectOptionType<any> | null | undefined;
  cidade: SelectOptionType<any> | null | undefined;
}

const DetalhesDoProcesso: React.FC<DetalhesDoProcessoProps> = (props) => {
  const {
    showModalAdicionarProcessoJudicialHistorico,
    showModalVisualizarProcessoJudicialHistorico,
    openCloseModalAdicionarProcessoJudicialHistorico,
    openCloseModalVisualizarProcessoJudicialHistorico,
  } = useProcessosJudiciaisContext();

  const { mutate } = usePutAtualizarProcessoJudicial();

  const { register, control, watch, handleSubmit, setValue, setError, clearErrors } = useForm<DetalhesDoProcessoForm>({
    resolver: yupResolver<DetalhesDoProcessoForm>(DetalhesProcessoJudicialSchema),
  });

  useEffect(() => {
    settarValoresDefault();
  }, []);

  const renderContentDadosProcesso = () => {
    return (
      <Row className="mb-2">
        <Col xs={6}>{renderDadosGerais()}</Col>
        <Col xs={6}>{renderInformacoesProcesso()}</Col>
      </Row>
    );
  };

  const settarValoresDefault = () => {
    if (props.processsoJudicial?.siglaUF !== null && props.processsoJudicial?.siglaUF !== undefined) {
      setValue("uf", { label: "AC", value: "AC" });
    }

    if (props.processsoJudicial?.cidadeId !== null && props.processsoJudicial?.cidadeId !== undefined) {
      setValue("cidade", { label: props.processsoJudicial.cidade as string, value: props.processsoJudicial.cidadeId });
    }
  };

  const renderDadosGerais = (): ReactNode => {
    return (
      <div className="container-dados-gerais">
        <h2 className="titulo mb-2">Dados gerais</h2>
        <Row className="mb-5">
          <Col xs={6}>
            <h3 className="sub-titulo">Número do processo</h3>
            <span>{props.processsoJudicial?.numeroProcesso}</span>
          </Col>
          <Col xs={6}>
            <h3 className="sub-titulo">Condomínio</h3>
            <span>{props.processsoJudicial?.nomeCondominio}</span>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h3 className="sub-titulo">Unidade</h3>
            <span>{props.processsoJudicial?.nomeUnidade}</span>
          </Col>
        </Row>
      </div>
    );
  };

  const renderInformacoesProcesso = (): ReactNode => {
    return (
      <div>
        <div className="d-flex justify-content-between">
          <h2 className="titulo mb-2">Informações do processo</h2>
          {renderButtonAtualizarDetalhesProcesso()}
        </div>
        <Row className="mb-3">
          <Col xs={6} sm={6} lg={6}>
            {renderCampoAdvogado()}
          </Col>
          <Col xs={6} sm={6} lg={6}>
            {renderCampoCartorio()}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col xs={6} sm={6} lg={6}>
            {renderCampoUf()}
          </Col>
          <Col xs={6} sm={6} lg={6}>
            {renderCampoCidade()}
          </Col>
        </Row>
      </div>
    );
  };

  const renderButtonAtualizarDetalhesProcesso = () => {
    if (!props.isVisualizacao) {
      return (
        <CustomButton
          className="ms-3 btn-adicionar-contatos"
          id="adicionar-detalhes-processo-judicial"
          label="Adicionar"
          variant="outline-primary"
          size="sm"
          leftIcon={AiOutlinePlus}
          onClick={() => handleSubmit(salvarDetalhesProcessoJudical)()}
        />
      );
    }
  };

  const renderCampoAdvogado = () => {
    if (props.isVisualizacao) {
      return <VisualizacaoInput id="advogado" label="Advogado" value={props.processsoJudicial?.nomeAdvogado} />;
    }
    return (
      <TextInput
        id="advogado"
        name="advogado"
        label="Advogado"
        key="advogado-input"
        defaultValue={props.processsoJudicial?.nomeAdvogado as string | undefined}
        usarValidacaoParaFormulario={true}
        control={control}
        setValue={setValue}
        register={register}
      />
    );
  };

  const renderCampoCartorio = () => {
    if (props.isVisualizacao) {
      return <VisualizacaoInput id="cartorio" label="Cartório" value={props.processsoJudicial?.cartorio} />;
    }
    return (
      <TextInput
        id="cartorio"
        name="cartorio"
        label="Cartório"
        setValue={setValue}
        control={control}
        register={register}
        key="cartorio-input"
        defaultValue={props.processsoJudicial?.cartorio as string | undefined}
        usarValidacaoParaFormulario
      />
    );
  };

  const renderCampoUf = () => {
    if (props.isVisualizacao) {
      return <VisualizacaoInput id="siglaUF" label="UF" value={props.processsoJudicial?.siglaUF} />;
    }

    return (
      <SelectAsync
        id="selecionar-condominio"
        nomeAtributoLabel="sigla"
        nomeAtributoValue="sigla"
        name={"uf"}
        isClearable={true}
        control={control}
        register={register}
        setValue={setValue}
        usarValidacaoParaFormulario
        onChange={() => {
          clearErrors("cidade");
          if (watch("cidade")) {
            setValue("cidade", null);
          }
        }}
        endpoint={api.endereco.getUnidadesFederativas}
        label={"UF"}
      />
    );
  };

  const renderCampoCidade = () => {
    if (props.isVisualizacao) {
      return <VisualizacaoInput id="cidade" label="Cidade" value={props.processsoJudicial?.cidade} />;
    }

    return (
      <SelectAsync
        usarValidacaoParaFormulario={true}
        id="cidade"
        name="cidade"
        setValue={setValue}
        control={control}
        register={register}
        label="Cidade"
        nomeAtributoValue="codigoIbge"
        isClearable
        nomeAtributoLabel="descricao"
        isDisabled={!watch("uf.value")}
        endpoint={`${api.endereco.getMunicipiosBySiglaUnidadeFederativa + watch("uf")?.value}`}
        atributosRefresh={[watch("uf.value")]}
      />
    );
  };

  const salvarDetalhesProcessoJudical = (form: DetalhesDoProcessoForm) => {
    if (watch("uf") && (watch("cidade") === undefined || watch("cidade") === null)) {
      setError("cidade", { message: mensagemDeErroPadrao("Cidade") });
      return;
    }

    const processoJudicialDTO = {
      id: props.processoId,
      nomeAdvogado: form.advogado,
      cartorio: form.cartorio,
      cidadeId: form.cidade?.value,
    } as ProcessosJudiciaisDTO;

    queryClient.invalidateQueries(["processos-judiciais"]);
    mutate(processoJudicialDTO);
  };

  const renderFooterDetalhesProcesso = (): ReactNode => {
    return (
      <Row>
        <Col className="d-flex justify-content-end">
          {!props.isVisualizacao && (
            <CustomButton
              id="btn-registrar-contato-realizado"
              label="Adicionar histórico"
              size="sm"
              onClick={openCloseModalAdicionarProcessoJudicialHistorico}
            />
          )}

          <div
            className="mt-2 ms-2 cursor-pointer hover-color"
            onClick={openCloseModalVisualizarProcessoJudicialHistorico}
          >
            <BsEye size={20} />
            <span className="ms-1">Visualizar histórico do processo</span>
          </div>
        </Col>
      </Row>
    );
  };

  return (
    <Section title="Detalhes do processo" icon={ImHammer2} footer={renderFooterDetalhesProcesso()}>
      {renderContentDadosProcesso()}

      <ModalAdicionarProcessoJudicialHistorico
        showModal={showModalAdicionarProcessoJudicialHistorico}
        onCloseModal={openCloseModalAdicionarProcessoJudicialHistorico}
        unidadeId={props.unidadeId}
        processoId={props.processoId}
      />

      <ModalVisualizarProcessoJudicialHistorico
        showModal={showModalVisualizarProcessoJudicialHistorico}
        onCloseModal={openCloseModalVisualizarProcessoJudicialHistorico}
        processoId={props.processoId}
      />
    </Section>
  );
};

export default DetalhesDoProcesso;
